// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-row.wrapper {
  align-items: center;
  background: white;
  color: var(--ion-color-dark);
  fill: var(--ion-color-dark);
  border-radius: 4px;
  height: 50px;
  display: flex;
  align-items: center;
}
ion-row.wrapper ion-icon {
  cursor: pointer;
}
ion-row.wrapper.active {
  padding: 0;
}
ion-row.wrapper.inactive {
  height: auto;
  padding: 8px;
}
ion-row.wrapper p {
  margin: 0;
  line-height: 90%;
}
ion-row.wrapper .hint {
  margin-top: 6px;
  display: block;
}

.add-text {
  font-family: AppFontMediumAlt;
  font-size: 16px;
  line-height: 21.76px;
  color: #346688;
}

.white-rounded-square {
  height: 30px;
  width: 30px;
}

.inactive .promo-icon {
  color: #b9b9b9;
  fill: #b9b9b9;
}

promo-icon {
  background: var(--ion-color-secondary);
}

.inactive > .white-rounded-square {
  color: #b9b9b9 !important;
  fill: #b9b9b9 !important;
}

ion-item {
  --border-radius: 4px;
  display: block;
  margin-bottom: 0;
}
ion-item ion-label {
  color: var(--ion-color-main);
  position: relative;
  margin-left: 5px;
}
ion-item ion-input {
  color: black;
  height: 0;
  margin-left: 5px;
}
ion-item ion-input.has-error {
  color: #ef5231;
}

.delete-promo {
  margin-left: 5px;
}

.submit-button {
  background: var(--ion-color-primary);
  border-radius: 4px;
  color: white;
  place-self: center;
}

.reg-row {
  width: 100%;
  color: var(--ion-color-secondary);
}
.reg-row__btn {
  flex: 1;
  background: #ffffff;
  border-radius: 5px;
  font-size: 16px;
  padding: 10px;
  text-align: center;
  cursor: pointer;
}
.reg-row__btn:first-child {
  margin-right: 8px;
}
.reg-row__btn:last-child {
  margin-left: 8px;
}

ion-spinner {
  display: block;
  margin: 10px auto;
}`, "",{"version":3,"sources":["webpack://./src/app/components/promo-code/promo-code.component.scss"],"names":[],"mappings":"AAAA;EACC,mBAAA;EACA,iBAAA;EACA,4BAAA;EACA,2BAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EAEA,mBAAA;AAAD;AAEC;EACC,eAAA;AAAF;AAGC;EACC,UAAA;AADF;AAIC;EACC,YAAA;EACA,YAAA;AAFF;AAKC;EACC,SAAA;EACA,gBAAA;AAHF;AAMC;EACC,eAAA;EACA,cAAA;AAJF;;AAQA;EACC,6BAAA;EACA,eAAA;EACA,oBAAA;EACA,cAAA;AALD;;AAQA;EACC,YAAA;EACA,WAAA;AALD;;AAQA;EACC,cAAA;EACA,aAAA;AALD;;AAOA;EACC,sCAAA;AAJD;;AAOA;EACC,yBAAA;EACA,wBAAA;AAJD;;AAOA;EACC,oBAAA;EACA,cAAA;EACA,gBAAA;AAJD;AAMC;EACC,4BAAA;EACA,kBAAA;EACA,gBAAA;AAJF;AAOC;EACC,YAAA;EACA,SAAA;EACA,gBAAA;AALF;AAOE;EACC,cAAA;AALH;;AAUA;EACC,gBAAA;AAPD;;AAUA;EACC,oCAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;AAPD;;AAUA;EACC,WAAA;EACA,iCAAA;AAPD;AASC;EACC,OAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;AAPF;AASE;EACC,iBAAA;AAPH;AAUE;EACC,gBAAA;AARH;;AAaA;EACC,cAAA;EACA,iBAAA;AAVD","sourcesContent":["ion-row.wrapper {\n\talign-items: center;\n\tbackground: white;\n\tcolor: var(--ion-color-dark);\n\tfill: var(--ion-color-dark);\n\tborder-radius: 4px;\n\theight: 50px;\n\tdisplay: flex;\n\t// justify-content: center;\n\talign-items: center;\n\n\tion-icon {\n\t\tcursor: pointer;\n\t}\n\n\t&.active {\n\t\tpadding: 0;\n\t}\n\n\t&.inactive {\n\t\theight: auto;\n\t\tpadding: 8px;\n\t}\n\n\tp {\n\t\tmargin: 0;\n\t\tline-height: 90%;\n\t}\n\n\t.hint {\n\t\tmargin-top: 6px;\n\t\tdisplay: block;\n\t}\n}\n\n.add-text {\n\tfont-family: AppFontMediumAlt;\n\tfont-size: 16px;\n\tline-height: 21.76px;\n\tcolor: #346688;\n}\n\n.white-rounded-square {\n\theight: 30px;\n\twidth: 30px;\n}\n\n.inactive .promo-icon {\n\tcolor: #b9b9b9;\n\tfill: #b9b9b9;\n}\npromo-icon {\n\tbackground: var(--ion-color-secondary);\n}\n\n.inactive > .white-rounded-square {\n\tcolor: #b9b9b9 !important;\n\tfill: #b9b9b9 !important;\n}\n\nion-item {\n\t--border-radius: 4px;\n\tdisplay: block;\n\tmargin-bottom: 0;\n\n\tion-label {\n\t\tcolor: var(--ion-color-main);\n\t\tposition: relative;\n\t\tmargin-left: 5px;\n\t}\n\n\tion-input {\n\t\tcolor: black;\n\t\theight: 0;\n\t\tmargin-left: 5px;\n\n\t\t&.has-error {\n\t\t\tcolor: #ef5231;\n\t\t}\n\t}\n}\n\n.delete-promo {\n\tmargin-left: 5px;\n}\n\n.submit-button {\n\tbackground: var(--ion-color-primary);\n\tborder-radius: 4px;\n\tcolor: white;\n\tplace-self: center;\n}\n\n.reg-row {\n\twidth: 100%;\n\tcolor: var(--ion-color-secondary);\n\n\t&__btn {\n\t\tflex: 1;\n\t\tbackground: #ffffff;\n\t\tborder-radius: 5px;\n\t\tfont-size: 16px;\n\t\tpadding: 10px;\n\t\ttext-align: center;\n\t\tcursor: pointer;\n\n\t\t&:first-child {\n\t\t\tmargin-right: 8px;\n\t\t}\n\n\t\t&:last-child {\n\t\t\tmargin-left: 8px;\n\t\t}\n\t}\n}\n\nion-spinner {\n\tdisplay: block;\n\tmargin: 10px auto;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
